// extracted by mini-css-extract-plugin
export var askAiIcon = "_nj-9";
export var container = "_nj-0";
export var groupSeparator = "_nj-a";
export var highlight = "_nj-4";
export var resultIcon = "_nj-5";
export var resultItem = "_nj-7";
export var resultSubtitle = "_nj-3";
export var resultTitle = "_nj-2";
export var resultsList = "_nj-1";
export var searchGroup = "_nj-6";
export var selected = "_nj-8";